export interface MicroCMSQueries {
  limit?: number;
  offset?: number;
}

export function toQueryString(queries: MicroCMSQueries): string {
  const { limit, offset } = queries;
  const resultList = [];
  if (limit) {
    resultList.push(`limit=${limit}`);
  }
  if (offset) {
    resultList.push(`offset=${offset}`);
  }

  return resultList.join("&");
}

export function makeFetchList(serviceDomain: string, apiKey: string, endpoint: string, queries?: MicroCMSQueries): Promise<Response> {
  const queryString = queries ? `?${toQueryString(queries)}` : "";
  return fetch(`https://${serviceDomain}.microcms.io/api/v1/${endpoint}${queryString}`, {
    headers: {
      "X-MICROCMS-API-KEY": apiKey,
    }
  });
}
export function makeFetchDetail(serviceDomain: string, apiKey: string, endpoint: string, id: string, queries?: MicroCMSQueries): Promise<Response> {
  const queryString = queries ? `?${toQueryString(queries)}` : "";
  return fetch(`https://${serviceDomain}.microcms.io/api/v1/${endpoint}/${id}${queryString}`, {
    headers: {
      "X-MICROCMS-API-KEY": apiKey,
    }
  });
}

export function throwUnlessOk(res: Response): void {
  if (!res.ok) {
    throw new Error(`HTTP Status: ${res.status}`);
  }

}